import { Page } from "./page";
import { Why } from "./why";

export class WhyOverview extends Page 
{
    items : Why[];
}
